import { Notice } from './ui.tsx';
import { useT } from '../i18n/I18n.tsx';

/**
 * Standing product disclosures.
 *
 * Not decoration: concept §5, §6 and §7 require both parties to be told about
 * endpoint copying, the bearer-link property and the limits of the encryption,
 * and acceptance item 25 makes it observable.
 *
 * They live here so the wording cannot drift between screens. What changed in
 * the redesign is presentation, not content — they were three stacked banners
 * dominating the join page, and are now placed where each is relevant and
 * collapsed behind a summary where they are supporting detail.
 *
 * They read from the catalogue rather than holding English inline. These are
 * the passages the product is obliged to communicate, so they are the last
 * place an untranslated string belongs: they were rendering English inside an
 * otherwise translated join page, which is where a reader is least able to
 * afford it.
 */

export function EndpointCopyingNotice() {
  const t = useT();
  return (
    <Notice tone="warn" title={t('disclosure.copyingTitle')}>
      {t('disclosure.copyingBody')}
    </Notice>
  );
}

export function BearerLinkNotice() {
  const t = useT();
  return (
    <Notice tone="warn" title={t('disclosure.bearerTitle')}>
      {t('disclosure.bearerBody')}
    </Notice>
  );
}

export function DeviceLocalKeyNotice() {
  const t = useT();
  return (
    <Notice tone="warn" title={t('disclosure.deviceKeyTitle')}>
      {t('disclosure.deviceKeyBody')}
    </Notice>
  );
}

export function EncryptionScopeNotice() {
  const t = useT();
  return (
    <Notice tone="info" title={t('disclosure.scopeTitle')}>
      <p>{t('disclosure.scopeBody1')}</p>
      <p>{t('disclosure.scopeBody2')}</p>
    </Notice>
  );
}

export function NotAnonymousNotice() {
  const t = useT();
  return (
    <Notice title={t('disclosure.notAnonymousTitle')}>{t('disclosure.notAnonymousBody')}</Notice>
  );
}

export function TemporaryNotice({ hours }: { hours: number }) {
  const t = useT();
  return (
    <Notice tone="info" title={t('disclosure.temporaryTitle')}>
      {t('disclosure.temporaryBody', { hours })}
    </Notice>
  );
}
